import { render } from "./DefaultInfoCard.vue?vue&type=template&id=c7ab5c9c&scoped=true"
import script from "./DefaultInfoCard.vue?vue&type=script&lang=js"
export * from "./DefaultInfoCard.vue?vue&type=script&lang=js"

import "./DefaultInfoCard.vue?vue&type=style&index=0&id=c7ab5c9c&scoped=true&lang=css"

import exportComponent from "/Users/iomac/Progetti/equiup/equiupmaneggi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ab5c9c"]])

export default __exports__